import { render, staticRenderFns } from "./AgendaDayGriglia.vue?vue&type=template&id=46603ca4&scoped=true"
import script from "./AgendaDayGriglia.vue?vue&type=script&lang=js"
export * from "./AgendaDayGriglia.vue?vue&type=script&lang=js"
import style0 from "./AgendaDayGriglia.vue?vue&type=style&index=0&id=46603ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46603ca4",
  null
  
)

export default component.exports